<app-form-field-group *ngIf="form">
  <div class="flex align-center bg-white brd brd-300 radius-2" [formGroup]="form">
    <mat-form-field appearance="outline" class="form-field--unbounded w-auto pl-3 pr-3">
      <mat-select #countrySelect="matSelect" formControlName="countryCode" (closed)="markTouched()">
        <mat-select-trigger>{{ countrySelect.value }}</mat-select-trigger>
        <mat-option *ngFor="let country of countries" [value]="country?.phoneKey">
          <span class="flex align-center gap-2">
            <span class="fi fi-{{ country?.isoCode | lowercase }}"></span>
            {{ country?.phoneKey }}
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field--unbounded box grow-fixed pl-0 pr-3">
      <input matInput type="text" [placeholder]="placeholder" formControlName="mobileNumber" (blur)="markTouched()" />
    </mat-form-field>
  </div>
</app-form-field-group>

<ng-container *ngIf="control?.touched">
  <mat-error class="small mt-1" *ngIf="control.hasError('required')">
    {{ 'ErrorMessages.Required' | translate }}
  </mat-error>
  <mat-error class="small mt-1" *ngIf="control.hasError('invalidPhoneNumberType')">
    {{ 'ErrorMessages.InvalidPhone' | translate }}
  </mat-error>
  <mat-error class="small mt-1" *ngIf="control.hasError('invalidPhoneNumberLength')">
    {{ 'ErrorMessages.InValidMobileLength' | translate: { length: MobileLengthPerCode[form.value.countryCode] } }}
  </mat-error>
</ng-container>
